'use strict';
module.exports = function GoldDrivePageState(config, navigatorModel) {
	const obj = this;
	let fileId, pageTitle, thumbnailExists, allowedActions = {share: false, trash: false, rename: false, upload: true};

	obj.isInitialised = false;
	obj.isInitialising = false;
	obj.setLoadConfig = function (loadConfig) {
		fileId = loadConfig && loadConfig.fileId;
		pageTitle = loadConfig && loadConfig.title;
		allowedActions = (loadConfig && loadConfig.allowedActions) || allowedActions;
		thumbnailExists = loadConfig && loadConfig.hasThumbnail;
		return loadConfig;
	};
	obj.applySaveConfig = function (saveConfig) {
		allowedActions = saveConfig.allowedActions;
		fileId = saveConfig.savedFileId;
		if (saveConfig.savedUrl) {
			navigatorModel.replaceUrl(pageTitle, saveConfig.savedUrl);
			return obj.getPathInfo(saveConfig.savedUrl);
		}
	};

	obj.hasThumbnail = () => !!thumbnailExists;
	obj.getPageTitle = function () {
		return pageTitle;
	};
	obj.getFileId = function () {
		return fileId;
	};
	obj.renamed = function (newName) {
		pageTitle = newName;
	};

	obj.getAllowedActions = function () {
		return Object.assign({}, allowedActions);
	};

	obj.getPathInfo = function (forUrl) {
		const path = forUrl || navigatorModel.getPath(),
			isCrowdLinkUrl = path === '/crowdlink.html',
			isEditorUrl = (path.indexOf(config.editorUrl) === 0 && path.length > config.editorUrl.length),
			componentPath = isEditorUrl && path.substring(config.editorUrl.length + 1),
			components = componentPath && componentPath.split('/'),
			getFileId = function (startIndex) {
				return components && components.length > startIndex && components.slice(startIndex).join('/');
			},
			freeMapInfo = function () {
				const freeFileId = getFileId(1);
				return {free: true, fileId: freeFileId};
			},
			crowdlinkMapInfo = () => {
				const crowdlinkFileId = navigatorModel.getQueryStringAsMap().fileId;
				return {fileId: crowdlinkFileId, gold: true, crowdlink: true, version: 1, allowedActions: allowedActions};
			},
			goldMapInfo = function () {
				const goldFileId = decodeURIComponent(getFileId(1));
				if (components[0] === '_v2') {
					return {fileId: goldFileId, gold: true, version: 2, uploadAssets: true, allowedActions: allowedActions};
				}
				return {account: components[0], fileId: goldFileId, gold: true, version: 1, allowedActions: allowedActions};
			},
			newFileInfo = function () {
				const newfileId = getFileId(1),
					theme = navigatorModel.getQueryStringAsMap().theme;
				if (newfileId) {
					return {new: true, fileId: newfileId, title: config.defaultFileTitle, allowedActions: allowedActions};
				} else {
					if (theme) {
						return {new: true, title: config.defaultFileTitle, allowedActions: allowedActions, theme: theme};
					}
					return {new: true, title: config.defaultFileTitle, allowedActions: allowedActions};
				}
			};
		if (isCrowdLinkUrl) {
			return crowdlinkMapInfo();
		}
		if (!components || components.length < 1 || (components[0].indexOf('_') === 0 && components[0] !== '_free' &&  components[0] !== '_legacy' &&  components[0] !== '_v2')) {
			return false;
		}
		if (components[0] === 'new') {
			return newFileInfo();
		}
		if (components[0] === '_free') {
			return freeMapInfo();
		}
		if (components[0] === '_legacy') {
			return {legacy: true, fileId: getFileId(1)};
		}
		return goldMapInfo();
	};

};

